import styles from './styles.module.scss';

const VARIANTS = {
  DEFAULT: '',
  SQUARE: 'square',
};

export default function CustomIcon({
  icon,
  alt,
  onClick,
  variant = VARIANTS.DEFAULT,
}) {
  return (
    <div
      className={`${
        variant === VARIANTS.SQUARE ? styles.squareIcon : styles.roundedIcon
      } bg-primary pointer`}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex={0}
    >
      <img src={icon} alt={alt} />
    </div>
  );
}
